const Loading = () => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100vw',
				height: '100vh'
			}}>
			<h1 style={{ fontSize: '40px' }}>Loading...</h1>
		</div>
	)
}

export default Loading
